import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import NewClaimIcon from 'assets/images/home/new-claim.svg';
import HealthDocumentIcon from 'assets/images/home/health-document.svg';
import { IconCard, type IconCardProps } from 'components/card';
import FourItemColumn from 'components/fourItemColumn';

import { RowSpaced } from '../styledComponents';
import { HomeContext } from 'contexts/home/context';

export const QuickAction = (): JSX.Element => {
  const { t } = useTranslation();

  const { state: homeState } = useContext(HomeContext);

  const iconCardItems: IconCardProps[] = useMemo(() => {
    const cards = [];
    if (homeState.userAccess?.submitClaim) {
      cards.push({
        to: '/claims/new',
        icon: NewClaimIcon,
        title: t('claims.fileANewClaimTitle'),
        description: t('claims.fileANewClaimDescription'),
      });
    }

    if (homeState.userAccess?.hasHOSP) {
      cards.push({
        to: '/claims/pre-claim',
        icon: HealthDocumentIcon,
        title: t('claims.preClaim'),
        description: t('claims.preclaimHospitalStayDescription'),
      });
    }
    return cards;
  }, [t, homeState]);

  return (
    <RowSpaced gutter={[{ xs: 8, sm: 16, md: 24 }, 16]} wrap>
      {iconCardItems.map(({ title, ...props }) => (
        <FourItemColumn key={title}>
          <IconCard title={title} {...props} />
        </FourItemColumn>
      ))}
    </RowSpaced>
  );
};
